import { Member } from '../member/member.model';
import { MediaObject } from '../media-object.model';
import { HrSkill } from './skill.model';
import { Catalog } from './catalog.model';
import { Tag } from './tag.model';

export class Course {
    /* Academy Properties */
    id: string;
    iri: string;
    name: string;
    goal: string;
    skills: HrSkill[];
    catalog: string | Catalog;
    educationalCredentialAwarded: string;
    duration: string;
    description: string;
    coursePrerequisites: string;
    language: string;
    maxTraineeCapacity: number;
    authors: Member[];
    media: MediaObject;
    price: number;
    isNotified: boolean;
    currency: string;
    createdBy: Member;
    dateCreated: string;
    dateModified: string;
    openForAll: boolean;
    /* Exchange Properties */
    targetPopulation?: string;
    recommendations?: string;
    teachingMethod?: string;
    resultsMonitoring?: string;
    youtubeTrailerId?: string;
    averageRating: number;
    ratingsCount: number;
    tags?: Tag[];

    constructor(json?) {
        if (json) {
            /* Assign Academy Properties */
            this.id = json.id;
            this.iri = json['@id'];
            this.name = json.name;
            this.goal = json.goal;
            this.skills = json.skills;
            this.catalog = json.catalog;
            this.educationalCredentialAwarded = json.educationalCredentialAwarded;
            this.duration = json.duration;
            this.description = json.description;
            this.coursePrerequisites = json.coursePrerequisites;
            this.language = json.language;
            this.maxTraineeCapacity = json.maxTraineeCapacity;
            this.media = json.media;
            this.authors = json.authors;
            this.price = json.price;
            this.isNotified = json.isNotified;
            this.currency = json.currency;
            this.createdBy = json.createdBy;
            this.dateCreated = json.dateCreated;
            this.dateModified = json.dateModified;
            this.openForAll = json.openForAll;
            /* Assign Exchange Properties */
            this.targetPopulation = json.targetPopulation;
            this.recommendations = json.recommendations;
            this.teachingMethod = json.teachingMethod;
            this.resultsMonitoring = json.resultsMonitoring;
            this.youtubeTrailerId = json.youtubeTrailerId;
            this.averageRating = json.averageRating;
            this.ratingsCount = json.ratingsCount;
            this.tags = json.tags;
        }
    }
}
